<template>
  <svg v-if="!isNorwegian" viewBox="0 0 4689.12 890.78" xmlns="http://www.w3.org/2000/svg">
    <g fill="#fff">
      <path
        d="m1010.97 201.33c-183.91 0-326.34 91.35-326.34 209.75 0 76.33 61.3 119.6 129.21 119.6 64.31 0 119-47.48 122.6-115.99 1.2-15.63 7.21-21.64 18.03-21.64s17.43 7.21 17.43 24.64c0 75.12-67.91 149.05-157.46 149.05-27.04 0-57.7-6.01-81.13-18.63-25.24 33.05-38.46 66.71-38.46 116.59 0 131.62 90.75 221.77 210.35 221.77 57.14 0 101.7-23.15 135.88-59.55l25.78 25.29c16.83 19.83 58.3 34.26 93.15 34.26 93.76 0 155.66-61.9 155.66-149.05v-247.61c0-174.89-119.6-288.48-304.71-288.48zm-12.62 445.94v-73.32c0-12.02 5.41-20.43 18.03-20.43s18.03 8.41 18.03 20.43v73.32c0 11.42-5.41 20.43-18.03 20.43s-18.03-9.02-18.03-20.43z"
      />
      <path
        d="m1507.4 0c-93.76 0-155.66 66.11-155.66 161.07v561.33c0 94.96 61.9 161.07 155.66 161.07s155.06-66.11 155.06-161.07v-561.33c0-94.96-61.9-161.07-155.06-161.07z"
      />
      <path
        d="m2193.74 204.34c-38.46 0-66.71 14.42-100.97 49.28l-63.71 64.91c-23.44 23.44-51.08 44.47-81.13 63.1-5.41 3.61-9.62 6.01-15.63 6.01-9.62 0-17.43-8.41-17.43-17.43 0-7.21 3-12.02 9.02-15.63 34.86-22.24 66.11-46.28 85.34-66.11v-127.41c0-94.96-61.9-161.07-155.06-161.07s-155.66 66.11-155.66 161.07v560.74c0 94.96 61.9 161.67 143.64 161.67s124.41-38.46 164.67-103.37l24.18-27.74 34.12 47.57c39.06 54.09 72.12 83.54 120.2 83.54 87.75 0 144.84-60.1 144.84-132.82 0-30.65-15.63-77.53-48.68-113.59l-76.34-84.46 55.85-64.07c61.64-69.5 71.57-103.08 71.57-148.37 0-67.91-60.1-135.83-138.83-135.83z"
      />
      <path
        d="m3194.41 204.34c-79.93 0-128.61 58.3-146.64 147.85l22.24 146.64c7.21 47.48 14.42 82.94 22.84 99.77 2.4 4.81 6.01 13.82 6.01 19.83 0 9.62-7.21 17.43-17.43 17.43-7.21 0-12.62-4.21-17.43-12.62-13.22-24.64-21.04-63.71-27.04-102.17l-27.04-174.29c-13.82-89.55-64.31-142.44-162.87-142.44-85.34 0-134.62 59.5-153.25 149.05l22.24 145.44c7.21 47.48 14.42 82.94 22.84 99.77 2.4 4.81 6.01 13.82 6.01 19.83 0 9.62-7.21 17.43-17.43 17.43-7.21 0-12.62-4.21-17.43-12.62-13.22-24.64-21.03-63.71-27.04-102.17l-27.04-174.29c-13.82-89.55-61.3-142.44-156.26-142.44s-147.24 51.69-147.24 155.66c0 46.88 9.62 90.15 19.83 129.21l50.48 192.92c27.04 103.37 103.97 204.34 226.58 204.34 113.59 0 183.91-57.7 201.93-123.81 11.55-43.98 16.53-85.98 18.35-111.7l34.42 83.16c4.93 13.94 10.5 27.56 16.79 40.55 30.57 63.2 78.13 111.79 151.62 111.79 122 0 189.31-100.97 213.35-203.74l45.68-193.52c10.22-43.27 15.02-84.14 15.02-128.01 0-105.17-57.09-156.86-152.05-156.86z"
      />
      <path
        d="m3690.85 201.33c-183.91 0-326.34 91.35-326.34 209.75 0 76.33 61.3 119.6 129.21 119.6 64.31 0 119-47.48 122.6-115.99 1.2-15.63 7.21-21.64 18.03-21.64s17.43 7.21 17.43 24.64c0 75.12-67.91 149.05-157.46 149.05-27.04 0-57.7-6.01-81.13-18.63-25.24 33.05-38.46 66.71-38.46 116.59 0 131.62 90.75 221.77 210.35 221.77 57.14 0 101.7-23.15 135.88-59.55l25.78 25.3c16.83 19.83 58.3 34.26 93.15 34.26 93.76 0 155.66-61.9 155.66-149.05v-247.61c0-174.89-119.6-288.48-304.71-288.48zm-12.62 445.94v-73.32c0-12.02 5.41-20.43 18.03-20.43s18.03 8.41 18.03 20.43v73.32c0 11.42-5.41 20.43-18.03 20.43s-18.03-9.02-18.03-20.43z"
      />
      <path
        d="m4187.28 0c-93.76 0-155.66 66.11-155.66 161.07v561.33c0 94.96 61.9 161.07 155.66 161.07s155.06-66.11 155.06-161.07v-561.33c0-94.96-61.9-161.07-155.06-161.07z"
      />
      <path
        d="m4534.06 0c-93.76 0-155.66 66.11-155.66 161.07v561.33c0 94.96 61.9 161.07 155.66 161.07s155.06-66.11 155.06-161.07v-561.33c0-94.96-61.9-161.07-155.06-161.07z"
      />
      <path
        d="m766.55 161.67c0-91.67-61.92-154.2-152.99-154.2h-460.57c-90.46 0-152.99 62.53-152.99 154.2s61.32 152.99 164.52 152.99c14.53 0 36.79-1.03 59.7-2.79v232.04h.3v178.71c0 99.56 60.71 168.16 159.06 168.16s159.06-68.6 159.06-168.16v-410.8c22.97 1.79 45.36 2.83 60 2.83 103.2 0 163.91-58.89 163.91-152.99z"
      />
    </g>
  </svg>
  <svg
    v-else
    version="1.1"
    class="logo"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1724 350"
    xml:space="preserve"
    fill="transparent"
  >
    <path
      opacity="1.000000"
      stroke="none"
      d="
M1189.000000,451.000000 
	C792.712097,451.000000 396.924225,451.000000 1.068162,451.000000 
	C1.068162,301.062683 1.068162,151.125336 1.068162,1.093991 
	C575.666687,1.093991 1150.333374,1.093991 1724.968750,1.093991 
	C1724.968750,151.076035 1724.968750,301.038025 1724.968750,451.000000 
	C1546.458374,451.000000 1367.979248,451.000000 1189.000000,451.000000 
M558.699097,221.501160 
	C558.725891,216.336411 558.660889,211.169022 558.809082,206.007767 
	C558.923401,202.026108 561.299988,200.479401 565.110718,200.746490 
	C570.097900,201.095993 570.160095,204.713974 570.161682,208.338455 
	C570.172546,232.833862 570.051575,257.330200 570.252991,281.823975 
	C570.300537,287.608154 570.786621,293.537384 572.155151,299.134796 
	C576.676025,317.625488 587.866455,330.355774 606.765686,334.501648 
	C625.739990,338.664001 642.947388,334.797241 656.059875,319.345612 
	C664.600647,309.281403 667.844116,297.138947 667.899048,284.149078 
	C668.006775,258.654327 667.924133,233.158768 667.939758,207.663559 
	C667.941956,204.068680 668.620728,200.965393 673.184265,200.692932 
	C677.814270,200.416473 679.410095,203.089417 679.589355,207.112503 
	C679.722656,210.106110 679.681641,213.108124 679.692017,216.106476 
	C679.778076,240.932037 678.482056,265.855682 680.243103,290.561554 
	C683.344849,334.074738 726.093750,344.194641 751.775574,330.274323 
	C769.645813,320.588104 776.470093,304.281311 776.726074,285.018188 
	C777.126892,254.862503 777.049988,224.695038 776.696228,194.538177 
	C776.593445,185.773987 775.645630,176.852600 773.735596,168.304855 
	C764.043213,124.930374 730.049744,110.510506 694.668823,116.468185 
	C673.322754,120.062569 658.901367,133.792343 648.917297,152.496231 
	C646.964233,156.154968 645.485657,160.190018 642.921753,163.347992 
	C641.628967,164.940323 638.089722,165.958557 636.138367,165.362686 
	C634.634766,164.903534 633.280457,161.544373 633.215454,159.432938 
	C633.144043,157.114487 634.242920,154.516418 635.497498,152.442947 
	C640.879150,143.548492 646.505920,134.802246 652.098511,125.914337 
	C640.520081,118.569595 626.644836,116.341537 612.439026,115.297180 
	C579.834900,112.900307 553.817627,127.632362 539.190979,156.789673 
	C538.148926,158.866943 537.638428,161.559113 536.005859,162.901001 
	C534.102661,164.465363 531.126770,165.713821 528.832214,165.418915 
	C527.579956,165.257950 526.242310,161.697281 525.933044,159.528687 
	C525.678162,157.741806 526.504333,155.518356 527.499146,153.882278 
	C533.238770,144.443146 539.170837,135.121048 545.254395,125.413567 
	C545.517212,125.659775 544.978821,125.013557 544.310242,124.558739 
	C542.937927,123.625175 541.543091,122.704025 540.075195,121.934891 
	C525.664673,114.383980 510.533020,113.068459 495.082214,117.668564 
	C474.221680,123.879257 461.459900,142.576767 461.344666,167.123352 
	C461.161652,206.115173 461.211273,245.108780 461.343750,284.101013 
	C461.387726,297.049408 464.592957,309.178528 472.977905,319.421448 
	C484.918945,334.008545 506.020966,339.726379 525.218628,333.761505 
	C543.360962,328.124542 556.930115,311.871826 557.860474,291.948761 
	C558.939758,268.836792 558.486877,245.653275 558.699097,221.501160 
M131.834824,336.697754 
	C140.647873,336.459991 149.527283,336.828796 158.261841,335.873413 
	C187.102539,332.718689 210.737015,320.162323 226.307480,295.067902 
	C239.248917,274.210541 243.380493,251.073334 239.811707,226.954498 
	C235.918381,200.642349 223.885666,178.523315 202.638870,161.970261 
	C200.694473,160.455414 197.853409,159.263245 195.448059,159.297058 
	C172.826935,159.615067 151.820770,153.054260 131.212448,144.690582 
	C128.918091,143.759445 126.209816,142.897705 124.750008,141.130844 
	C123.320312,139.400467 122.093597,135.998184 122.890800,134.354630 
	C123.689842,132.707291 127.039917,131.853699 129.386826,131.554871 
	C130.983093,131.351593 132.808868,132.631516 134.478241,133.369797 
	C155.874939,142.832474 178.087036,148.182281 201.658676,148.082550 
	C235.734009,147.938354 248.198120,116.105980 239.342072,92.817146 
	C233.492889,77.435501 221.549927,67.850586 207.131592,61.083450 
	C184.540680,50.480587 160.484924,48.046513 135.960327,49.390907 
	C117.715050,50.391079 100.621300,55.527229 85.563278,66.264992 
	C61.565620,83.377533 49.936794,107.385681 47.531380,136.171326 
	C44.803986,168.810135 54.999603,196.818314 78.827850,219.547455 
	C80.335411,220.985474 82.821564,222.210266 84.833893,222.182648 
	C109.142853,221.848953 131.816910,228.475769 153.839157,237.982712 
	C155.638992,238.759674 157.802887,239.669891 158.753891,241.176865 
	C159.820999,242.867783 160.613419,245.766602 159.844803,247.294434 
	C159.054855,248.864700 156.324081,249.852600 154.276245,250.260956 
	C152.852783,250.544769 151.125824,249.479370 149.572739,248.912003 
	C140.547256,245.614899 131.612793,242.046112 122.495827,239.027466 
	C109.897690,234.856186 96.792915,234.140778 83.606407,233.612137 
	C48.207207,232.192963 32.992413,266.708099 43.578442,292.514038 
	C50.191895,308.635864 63.576340,317.837921 78.670967,324.808502 
	C95.198196,332.440643 112.865028,335.449554 131.834824,336.697754 
M321.214600,336.842987 
	C335.146790,335.818329 347.359772,330.803650 357.320984,321.179138 
	C370.405823,331.237061 385.044006,336.822235 401.258789,336.805115 
	C428.153687,336.776672 448.203156,319.446930 449.229401,292.721863 
	C450.493744,259.795044 450.745331,226.653687 448.454163,193.812973 
	C445.912476,157.380707 421.107483,129.683167 385.753510,119.985001 
	C352.766907,110.936264 320.439392,114.205215 289.163544,127.759468 
	C273.881317,134.382446 260.964569,144.086426 252.198868,158.585556 
	C242.871521,174.013718 243.333511,194.409653 253.137909,206.582321 
	C263.609253,219.583038 282.961578,225.120224 299.815643,219.938004 
	C315.390289,215.149200 325.465515,201.946442 326.984985,184.182434 
	C327.319122,180.276199 328.487854,177.090729 333.036835,177.250916 
	C337.387024,177.404114 338.190979,180.777847 338.404053,184.324173 
	C338.463562,185.314651 338.400208,186.317245 338.331604,187.310013 
	C336.610168,212.212967 314.937561,233.104935 289.638794,233.080154 
	C280.058990,233.070770 270.481598,230.586212 260.077515,229.112991 
	C260.342682,228.783051 259.639954,229.504883 259.111420,230.337311 
	C243.879593,254.327774 245.640762,279.103729 258.143921,302.934753 
	C270.977448,327.395508 293.077026,337.438782 321.214600,336.842987 
M1127.166626,304.551178 
	C1127.929443,300.308289 1129.345947,296.066193 1129.351074,291.822388 
	C1129.389160,260.175293 1130.747070,228.417603 1128.574951,196.909424 
	C1126.055054,160.357834 1106.572998,134.041931 1071.371948,121.975861 
	C1034.847290,109.456032 998.791565,113.560631 964.251038,130.055649 
	C948.777527,137.445084 936.154846,148.441299 929.037720,164.657425 
	C918.769714,188.052795 929.081116,212.287811 952.382751,219.619507 
	C978.404236,227.807022 1002.648010,213.405670 1006.610168,187.387924 
	C1006.910095,185.417877 1006.432068,183.032074 1007.396423,181.536423 
	C1008.579346,179.701691 1010.915222,177.479095 1012.725403,177.502838 
	C1014.485046,177.525925 1016.512146,179.956207 1017.832458,181.760651 
	C1018.574768,182.775085 1018.217590,184.662903 1018.198486,186.155243 
	C1017.902771,209.310104 996.872620,231.189392 973.171936,233.090027 
	C962.051086,233.981857 951.350220,232.376938 941.333740,227.713486 
	C921.922180,249.469757 925.307007,292.534485 947.522766,316.638580 
	C968.405029,339.295868 1014.574341,347.371368 1041.269897,317.647736 
	C1062.868408,348.478027 1115.709717,341.009369 1127.166626,304.551178 
M1523.364624,231.020050 
	C1509.024414,235.265930 1495.113892,233.639908 1481.665649,227.786697 
	C1462.721069,247.208923 1465.313965,291.887573 1486.308472,314.925598 
	C1498.486084,328.288605 1513.582275,335.374176 1531.379150,336.734650 
	C1550.068481,338.163330 1566.496704,332.836700 1578.890503,319.730957 
	C1586.862061,324.516998 1593.908936,330.101013 1601.908936,333.305298 
	C1629.366577,344.303009 1659.325928,330.649902 1667.530151,304.000763 
	C1668.694458,300.219055 1669.689941,296.187592 1669.682007,292.273926 
	C1669.616699,259.967865 1670.876343,227.551300 1668.616699,195.387253 
	C1666.272949,162.025665 1648.601440,137.074310 1617.161133,124.075752 
	C1582.973755,109.941544 1548.397949,112.851242 1514.432495,125.553841 
	C1496.616577,132.216797 1481.133789,142.590164 1471.694214,159.760269 
	C1458.923706,182.989700 1465.380737,213.278198 1496.003662,220.504089 
	C1518.599854,225.835953 1539.418579,214.596603 1545.467041,193.722687 
	C1546.382935,190.562012 1546.669678,187.196854 1547.026489,183.902328 
	C1547.427734,180.198227 1548.724976,177.197144 1552.922119,177.258072 
	C1557.216797,177.320435 1558.441040,180.598709 1558.411621,184.181381 
	C1558.382935,187.650635 1558.232910,191.225418 1557.386230,194.563583 
	C1552.820923,212.559036 1541.190308,224.225616 1523.364624,231.020050 
M1266.389648,250.878983 
	C1263.123413,256.116364 1258.802124,256.283875 1255.697510,251.146973 
	C1254.508423,249.179428 1253.503906,246.995316 1252.931641,244.776703 
	C1248.869141,229.024429 1244.799072,213.271500 1241.008545,197.452362 
	C1237.175537,181.455688 1234.388672,165.171387 1229.809448,149.400497 
	C1224.900146,132.493362 1214.125488,120.239731 1195.807861,117.534523 
	C1187.201416,116.263474 1178.116089,116.150208 1169.512451,117.373795 
	C1151.156372,119.984337 1139.582764,131.968918 1135.972412,150.209335 
	C1133.410522,163.153076 1133.633057,176.194992 1136.656982,188.891418 
	C1143.471436,217.503952 1150.222778,246.167892 1158.345093,274.424194 
	C1171.173096,319.049927 1214.011230,344.908447 1258.618042,334.831848 
	C1292.601929,327.154907 1312.989258,304.219360 1322.923340,271.679962 
	C1328.451050,253.573471 1332.852905,235.123169 1337.757568,216.826553 
	C1342.675659,198.480164 1347.236450,180.118271 1346.148926,160.828751 
	C1344.636963,134.009750 1331.009033,118.785263 1304.367432,116.520027 
	C1277.026367,114.195320 1262.296265,123.192558 1254.150391,143.461472 
	C1250.796021,151.807968 1249.562256,161.006683 1247.364014,169.817795 
	C1253.330078,195.012360 1255.544556,221.117157 1265.694702,245.303711 
	C1266.317139,246.787018 1266.320068,248.530273 1266.389648,250.878983 
M888.531799,94.146973 
	C883.097168,60.821999 856.070801,43.335476 823.456909,52.042377 
	C802.242615,57.705959 788.550842,77.133514 788.514038,102.082031 
	C788.435547,155.229233 788.458557,208.376648 788.511902,261.523895 
	C788.525452,275.015778 791.077637,287.989960 797.436340,300.031525 
	C812.122253,327.842438 844.315674,342.281494 876.335510,335.456879 
	C903.541809,329.658203 919.134094,308.353699 915.813049,280.735321 
	C913.864136,264.528381 905.471924,252.624359 889.424927,246.266006 
	C889.424927,228.427124 889.424927,210.702271 889.424927,192.985367 
	C910.382324,189.089523 919.949585,178.358032 920.732239,157.617249 
	C921.087341,148.209229 918.703857,139.472275 913.091187,131.794495 
	C907.167297,123.690987 898.932312,119.599617 890.001160,118.834953 
	C889.533630,110.541756 889.096619,102.789925 888.531799,94.146973 
M1455.699585,170.500153 
	C1455.699585,148.505981 1455.733765,126.511726 1455.668335,104.517754 
	C1455.656372,100.530922 1455.576538,96.490639 1454.946899,92.568314 
	C1451.716675,72.444359 1441.071289,58.226860 1421.167114,52.169983 
	C1400.626099,45.919373 1378.611328,52.395191 1366.316284,67.680595 
	C1358.099731,77.895462 1355.106567,89.800957 1355.094482,102.582809 
	C1355.037354,162.900085 1355.068359,223.217453 1355.073120,283.534790 
	C1355.073242,284.867035 1355.077026,286.203735 1355.178101,287.530823 
	C1356.677246,307.179657 1364.585815,323.210388 1383.297974,331.278625 
	C1402.114868,339.392059 1420.875366,338.138641 1437.577026,325.352264 
	C1451.020264,315.060333 1455.644531,300.340759 1455.676392,283.970306 
	C1455.749268,246.480377 1455.699585,208.990234 1455.699585,170.500153 
z"
    />
    <path
      fill="#FEFEFE"
      opacity="1.000000"
      stroke="none"
      d="
M558.699097,222.000992 
	C558.486877,245.653275 558.939758,268.836792 557.860474,291.948761 
	C556.930115,311.871826 543.360962,328.124542 525.218628,333.761505 
	C506.020966,339.726379 484.918945,334.008545 472.977905,319.421448 
	C464.592957,309.178528 461.387726,297.049408 461.343750,284.101013 
	C461.211273,245.108780 461.161652,206.115173 461.344666,167.123352 
	C461.459900,142.576767 474.221680,123.879257 495.082214,117.668564 
	C510.533020,113.068459 525.664673,114.383980 540.075195,121.934891 
	C541.543091,122.704025 542.937927,123.625175 544.310242,124.558739 
	C544.978821,125.013557 545.517212,125.659775 545.254395,125.413567 
	C539.170837,135.121048 533.238770,144.443146 527.499146,153.882278 
	C526.504333,155.518356 525.678162,157.741806 525.933044,159.528687 
	C526.242310,161.697281 527.579956,165.257950 528.832214,165.418915 
	C531.126770,165.713821 534.102661,164.465363 536.005859,162.901001 
	C537.638428,161.559113 538.148926,158.866943 539.190979,156.789673 
	C553.817627,127.632362 579.834900,112.900307 612.439026,115.297180 
	C626.644836,116.341537 640.520081,118.569595 652.098511,125.914337 
	C646.505920,134.802246 640.879150,143.548492 635.497498,152.442947 
	C634.242920,154.516418 633.144043,157.114487 633.215454,159.432938 
	C633.280457,161.544373 634.634766,164.903534 636.138367,165.362686 
	C638.089722,165.958557 641.628967,164.940323 642.921753,163.347992 
	C645.485657,160.190018 646.964233,156.154968 648.917297,152.496231 
	C658.901367,133.792343 673.322754,120.062569 694.668823,116.468185 
	C730.049744,110.510506 764.043213,124.930374 773.735596,168.304855 
	C775.645630,176.852600 776.593445,185.773987 776.696228,194.538177 
	C777.049988,224.695038 777.126892,254.862503 776.726074,285.018188 
	C776.470093,304.281311 769.645813,320.588104 751.775574,330.274323 
	C726.093750,344.194641 683.344849,334.074738 680.243103,290.561554 
	C678.482056,265.855682 679.778076,240.932037 679.692017,216.106476 
	C679.681641,213.108124 679.722656,210.106110 679.589355,207.112503 
	C679.410095,203.089417 677.814270,200.416473 673.184265,200.692932 
	C668.620728,200.965393 667.941956,204.068680 667.939758,207.663559 
	C667.924133,233.158768 668.006775,258.654327 667.899048,284.149078 
	C667.844116,297.138947 664.600647,309.281403 656.059875,319.345612 
	C642.947388,334.797241 625.739990,338.664001 606.765686,334.501648 
	C587.866455,330.355774 576.676025,317.625488 572.155151,299.134796 
	C570.786621,293.537384 570.300537,287.608154 570.252991,281.823975 
	C570.051575,257.330200 570.172546,232.833862 570.161682,208.338455 
	C570.160095,204.713974 570.097900,201.095993 565.110718,200.746490 
	C561.299988,200.479401 558.923401,202.026108 558.809082,206.007767 
	C558.660889,211.169022 558.725891,216.336411 558.699097,222.000992 
z"
    />
    <path
      fill="#FEFEFE"
      opacity="1.000000"
      stroke="none"
      d="
M131.366699,336.671326 
	C112.865028,335.449554 95.198196,332.440643 78.670967,324.808502 
	C63.576340,317.837921 50.191895,308.635864 43.578442,292.514038 
	C32.992413,266.708099 48.207207,232.192963 83.606407,233.612137 
	C96.792915,234.140778 109.897690,234.856186 122.495827,239.027466 
	C131.612793,242.046112 140.547256,245.614899 149.572739,248.912003 
	C151.125824,249.479370 152.852783,250.544769 154.276245,250.260956 
	C156.324081,249.852600 159.054855,248.864700 159.844803,247.294434 
	C160.613419,245.766602 159.820999,242.867783 158.753891,241.176865 
	C157.802887,239.669891 155.638992,238.759674 153.839157,237.982712 
	C131.816910,228.475769 109.142853,221.848953 84.833893,222.182648 
	C82.821564,222.210266 80.335411,220.985474 78.827850,219.547455 
	C54.999603,196.818314 44.803986,168.810135 47.531380,136.171326 
	C49.936794,107.385681 61.565620,83.377533 85.563278,66.264992 
	C100.621300,55.527229 117.715050,50.391079 135.960327,49.390907 
	C160.484924,48.046513 184.540680,50.480587 207.131592,61.083450 
	C221.549927,67.850586 233.492889,77.435501 239.342072,92.817146 
	C248.198120,116.105980 235.734009,147.938354 201.658676,148.082550 
	C178.087036,148.182281 155.874939,142.832474 134.478241,133.369797 
	C132.808868,132.631516 130.983093,131.351593 129.386826,131.554871 
	C127.039917,131.853699 123.689842,132.707291 122.890800,134.354630 
	C122.093597,135.998184 123.320312,139.400467 124.750008,141.130844 
	C126.209816,142.897705 128.918091,143.759445 131.212448,144.690582 
	C151.820770,153.054260 172.826935,159.615067 195.448059,159.297058 
	C197.853409,159.263245 200.694473,160.455414 202.638870,161.970261 
	C223.885666,178.523315 235.918381,200.642349 239.811707,226.954498 
	C243.380493,251.073334 239.248917,274.210541 226.307480,295.067902 
	C210.737015,320.162323 187.102539,332.718689 158.261841,335.873413 
	C149.527283,336.828796 140.647873,336.459991 131.366699,336.671326 
z"
    />
    <path
      fill="#FEFEFE"
      opacity="1.000000"
      stroke="none"
      d="
M320.748688,336.868591 
	C293.077026,337.438782 270.977448,327.395508 258.143921,302.934753 
	C245.640762,279.103729 243.879593,254.327774 259.111420,230.337311 
	C259.639954,229.504883 260.342682,228.783051 260.077515,229.112991 
	C270.481598,230.586212 280.058990,233.070770 289.638794,233.080154 
	C314.937561,233.104935 336.610168,212.212967 338.331604,187.310013 
	C338.400208,186.317245 338.463562,185.314651 338.404053,184.324173 
	C338.190979,180.777847 337.387024,177.404114 333.036835,177.250916 
	C328.487854,177.090729 327.319122,180.276199 326.984985,184.182434 
	C325.465515,201.946442 315.390289,215.149200 299.815643,219.938004 
	C282.961578,225.120224 263.609253,219.583038 253.137909,206.582321 
	C243.333511,194.409653 242.871521,174.013718 252.198868,158.585556 
	C260.964569,144.086426 273.881317,134.382446 289.163544,127.759468 
	C320.439392,114.205215 352.766907,110.936264 385.753510,119.985001 
	C421.107483,129.683167 445.912476,157.380707 448.454163,193.812973 
	C450.745331,226.653687 450.493744,259.795044 449.229401,292.721863 
	C448.203156,319.446930 428.153687,336.776672 401.258789,336.805115 
	C385.044006,336.822235 370.405823,331.237061 357.320984,321.179138 
	C347.359772,330.803650 335.146790,335.818329 320.748688,336.868591 
M356.350067,265.056732 
	C357.166779,263.289825 358.634979,261.542389 358.688416,259.752716 
	C358.931702,251.604828 358.872131,243.443329 358.723511,235.290344 
	C358.653351,231.441437 356.709290,228.870575 352.528473,229.126999 
	C348.340820,229.383820 346.999512,232.264648 346.992981,236.027496 
	C346.979675,243.684784 346.903839,251.343369 347.016174,258.999023 
	C347.105225,265.066528 349.370209,266.679657 356.350067,265.056732 
z"
    />
    <path
      fill="#FEFEFE"
      opacity="1.000000"
      stroke="none"
      d="
M1127.068115,304.937195 
	C1115.709717,341.009369 1062.868408,348.478027 1041.269897,317.647736 
	C1014.574341,347.371368 968.405029,339.295868 947.522766,316.638580 
	C925.307007,292.534485 921.922180,249.469757 941.333740,227.713486 
	C951.350220,232.376938 962.051086,233.981857 973.171936,233.090027 
	C996.872620,231.189392 1017.902771,209.310104 1018.198486,186.155243 
	C1018.217590,184.662903 1018.574768,182.775085 1017.832458,181.760651 
	C1016.512146,179.956207 1014.485046,177.525925 1012.725403,177.502838 
	C1010.915222,177.479095 1008.579346,179.701691 1007.396423,181.536423 
	C1006.432068,183.032074 1006.910095,185.417877 1006.610168,187.387924 
	C1002.648010,213.405670 978.404236,227.807022 952.382751,219.619507 
	C929.081116,212.287811 918.769714,188.052795 929.037720,164.657425 
	C936.154846,148.441299 948.777527,137.445084 964.251038,130.055649 
	C998.791565,113.560631 1034.847290,109.456032 1071.371948,121.975861 
	C1106.572998,134.041931 1126.055054,160.357834 1128.574951,196.909424 
	C1130.747070,228.417603 1129.389160,260.175293 1129.351074,291.822388 
	C1129.345947,296.066193 1127.929443,300.308289 1127.068115,304.937195 
M1038.505615,248.486008 
	C1038.499146,244.004959 1038.572388,239.521942 1038.461548,235.043472 
	C1038.369873,231.341431 1036.527588,229.023270 1032.625488,229.116867 
	C1028.781250,229.209076 1026.969727,231.514694 1026.954590,235.237289 
	C1026.921021,243.535370 1026.902466,251.834152 1026.977173,260.131744 
	C1027.008057,263.561737 1028.599487,265.828094 1032.300171,266.043457 
	C1036.253174,266.273529 1038.173096,264.075806 1038.399048,260.420258 
	C1038.623901,256.782227 1038.484985,253.121719 1038.505615,248.486008 
z"
    />
    <path
      fill="#FEFEFE"
      opacity="1.000000"
      stroke="none"
      d="
M1523.758179,230.947968 
	C1541.190308,224.225616 1552.820923,212.559036 1557.386230,194.563583 
	C1558.232910,191.225418 1558.382935,187.650635 1558.411621,184.181381 
	C1558.441040,180.598709 1557.216797,177.320435 1552.922119,177.258072 
	C1548.724976,177.197144 1547.427734,180.198227 1547.026489,183.902328 
	C1546.669678,187.196854 1546.382935,190.562012 1545.467041,193.722687 
	C1539.418579,214.596603 1518.599854,225.835953 1496.003662,220.504089 
	C1465.380737,213.278198 1458.923706,182.989700 1471.694214,159.760269 
	C1481.133789,142.590164 1496.616577,132.216797 1514.432495,125.553841 
	C1548.397949,112.851242 1582.973755,109.941544 1617.161133,124.075752 
	C1648.601440,137.074310 1666.272949,162.025665 1668.616699,195.387253 
	C1670.876343,227.551300 1669.616699,259.967865 1669.682007,292.273926 
	C1669.689941,296.187592 1668.694458,300.219055 1667.530151,304.000763 
	C1659.325928,330.649902 1629.366577,344.303009 1601.908936,333.305298 
	C1593.908936,330.101013 1586.862061,324.516998 1578.890503,319.730957 
	C1566.496704,332.836700 1550.068481,338.163330 1531.379150,336.734650 
	C1513.582275,335.374176 1498.486084,328.288605 1486.308472,314.925598 
	C1465.313965,291.887573 1462.721069,247.208923 1481.665649,227.786697 
	C1495.113892,233.639908 1509.024414,235.265930 1523.758179,230.947968 
M1577.585693,263.921936 
	C1578.008301,262.335419 1578.769287,260.754517 1578.795898,259.161377 
	C1578.923706,251.501984 1578.879639,243.839157 1578.841919,236.177841 
	C1578.822510,232.251083 1577.513306,229.131943 1572.963257,229.130814 
	C1568.443848,229.129684 1567.058105,232.144424 1567.055908,236.138519 
	C1567.051758,243.800034 1566.941528,251.463715 1567.087769,259.122437 
	C1567.214966,265.774628 1571.101807,267.806488 1577.585693,263.921936 
z"
    />
    <path
      fill="#FEFEFE"
      opacity="1.000000"
      stroke="none"
      d="
M1266.500366,250.515778 
	C1266.320068,248.530273 1266.317139,246.787018 1265.694702,245.303711 
	C1255.544556,221.117157 1253.330078,195.012360 1247.364014,169.817780 
	C1249.562256,161.006683 1250.796021,151.807968 1254.150391,143.461472 
	C1262.296265,123.192558 1277.026367,114.195320 1304.367432,116.520027 
	C1331.009033,118.785263 1344.636963,134.009750 1346.148926,160.828751 
	C1347.236450,180.118271 1342.675659,198.480164 1337.757568,216.826553 
	C1332.852905,235.123169 1328.451050,253.573471 1322.923340,271.679962 
	C1312.989258,304.219360 1292.601929,327.154907 1258.618042,334.831848 
	C1214.011230,344.908447 1171.173096,319.049927 1158.345093,274.424194 
	C1150.222778,246.167892 1143.471436,217.503952 1136.656982,188.891418 
	C1133.633057,176.194992 1133.410522,163.153076 1135.972412,150.209335 
	C1139.582764,131.968918 1151.156372,119.984337 1169.512451,117.373795 
	C1178.116089,116.150208 1187.201416,116.263474 1195.807861,117.534523 
	C1214.125488,120.239731 1224.900146,132.493362 1229.809448,149.400497 
	C1234.388672,165.171387 1237.175537,181.455688 1241.008545,197.452362 
	C1244.799072,213.271500 1248.869141,229.024429 1252.931641,244.776703 
	C1253.503906,246.995316 1254.508423,249.179428 1255.697510,251.146973 
	C1258.802124,256.283875 1263.123413,256.116364 1266.500366,250.515778 
z"
    />
    <path
      fill="#FEFEFE"
      opacity="1.000000"
      stroke="none"
      d="
M888.595703,94.592529 
	C889.096619,102.789925 889.533630,110.541756 890.001160,118.834953 
	C898.932312,119.599617 907.167297,123.690987 913.091187,131.794495 
	C918.703857,139.472275 921.087341,148.209229 920.732239,157.617249 
	C919.949585,178.358032 910.382324,189.089523 889.424927,192.985367 
	C889.424927,210.702271 889.424927,228.427124 889.424927,246.266006 
	C905.471924,252.624359 913.864136,264.528381 915.813049,280.735321 
	C919.134094,308.353699 903.541809,329.658203 876.335510,335.456879 
	C844.315674,342.281494 812.122253,327.842438 797.436340,300.031525 
	C791.077637,287.989960 788.525452,275.015778 788.511902,261.523895 
	C788.458557,208.376648 788.435547,155.229233 788.514038,102.082031 
	C788.550842,77.133514 802.242615,57.705959 823.456909,52.042377 
	C856.070801,43.335476 883.097168,60.821999 888.595703,94.592529 
z"
    />
    <path
      fill="#FEFEFE"
      opacity="1.000000"
      stroke="none"
      d="
M1455.699585,171.000168 
	C1455.699585,208.990234 1455.749268,246.480377 1455.676392,283.970306 
	C1455.644531,300.340759 1451.020264,315.060333 1437.577026,325.352264 
	C1420.875366,338.138641 1402.114868,339.392059 1383.297974,331.278625 
	C1364.585815,323.210388 1356.677246,307.179657 1355.178101,287.530823 
	C1355.077026,286.203735 1355.073242,284.867035 1355.073120,283.534790 
	C1355.068359,223.217453 1355.037354,162.900085 1355.094482,102.582809 
	C1355.106567,89.800957 1358.099731,77.895462 1366.316284,67.680595 
	C1378.611328,52.395191 1400.626099,45.919373 1421.167114,52.169983 
	C1441.071289,58.226860 1451.716675,72.444359 1454.946899,92.568314 
	C1455.576538,96.490639 1455.656372,100.530922 1455.668335,104.517754 
	C1455.733765,126.511726 1455.699585,148.505981 1455.699585,171.000168 
z"
    />
  </svg>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  import useCommonStore from '@/composables/common'

  const common = useCommonStore()

  const isNorwegian = computed(() => {
    return common.getters.languageCode.value.toLowerCase().includes('no')
  })
</script>

<style scoped>
  svg {
    height: 1.2rem;
  }
  .logo {
    height: 1.4rem;
  }
</style>
